export enum RemunerationEnum {
  FULLY_REMUNERATED = "FULLY_REMUNERATED",
  NOT_REMUNERATED = "NOT_REMUNERATED",
  PILOT_PHASE = "PILOT_PHASE",
  INTERNET_PROVIDER_PAYMENT = "INTERNET_PROVIDER_PAYMENT",
  PARTIALLY_REMUNERATED = "PARTIALLY_REMUNERATED",
}

export const RemunerationEnumMapping: Record<RemunerationEnum, string> = {
  [RemunerationEnum.FULLY_REMUNERATED]: "enumMapping.remuneration.Renumerated",
  [RemunerationEnum.NOT_REMUNERATED]: "enumMapping.remuneration.NotRenumerated",
  [RemunerationEnum.PILOT_PHASE]: "enumMapping.remuneration.pilotPhase",
  [RemunerationEnum.INTERNET_PROVIDER_PAYMENT]:
    "enumMapping.remuneration.internetProvidePayment",
  [RemunerationEnum.PARTIALLY_REMUNERATED]: "enumMapping.remuneration.partiallyRemunerated"
};
